import { GenericDialog } from '~/components/commons/genericDialog/GenericDialog';
import { ErrorInfos } from '../../Error/ErrorInfos';
import { useApiErrorContext } from '../../Provider';

export function ApiErrorDialog() {
  const { setError } = useApiErrorContext();
  return (
    <GenericDialog
      isOpen
      isClosable
      onClose={() => setError(null)}
      content={<ErrorInfos />}
    />
  );
}
